import React from "react";
//components
import Select from "pages/Quotes/components/generics/Select";
import Tooltip from "../generics/tooltips/TooltipButton";
import { Visibility } from "components/Visibility";
import { Column } from "components/Layout/Grid";
import { Button } from "components/Button";
import Text from "components/Text";
//assets
import ObsIcon from "img/ObsIcon.svg";
import ObsIconSaved from "img/SavedObsIcon.svg";
//interfaces
import { IDetailsHeaderButtons } from "./interface";
import { StatusType, SupplierStatusType } from "components/Table/interface";
//services
import QuoteServices from "services/quote.service";
// context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
import { toastCanceled } from "pages/Quotes/utils/Quotes";
import { useNavigate } from "react-router-dom";
//styles
import { ColumnContent, CustomButton, FirstRow, SecondRow, SelectColumn } from "./styles";

export const DetailsHeaderButtons: React.FC<IDetailsHeaderButtons> = (props) => {
  const {
    user,
    quoteId,
    selectCD,
    disableBtn,
    toolTipText,
    savedBudgets,
    blockedDispatch,
    productSelected,
    obsIconCondition,
    distributionCenter,
    setOpenItemObsModal,
    changeCDAndResetQuote,
    setModalNotParticipate,
    isActiveNotParticipate,
    notParticipateStatusLabel,
    checkIsBudgetSavedOthersUsers
  } = props;

  const { quoteDetail, setModalPaymentTermModal } = useDetailsQuoteContext();

  const navigate = useNavigate();
  const _quoteServices = new QuoteServices();

  const enableButtons = (quoteDetail?.status !== StatusType.CLOSED && quoteDetail?.supplierStatus !== SupplierStatusType.EXPIRED) ||
    (quoteDetail?.status !== StatusType.CLOSED && quoteDetail.supplierStatus !== SupplierStatusType.DO_NOT_PARTICIPATE);

  const navigateDash = () => {
    return navigate('/cotacoes-dashboard');
  };

  const isQuoteCanceled = async () => {
    const response = await _quoteServices.statusCanceled(quoteId ?? "");
    if (response.status === 200) {
      if (response.data.isCanceled) {
        toastCanceled(navigateDash);
      } else {
        checkIsBudgetSavedOthersUsers(
          setModalPaymentTermModal,
          savedBudgets,
          blockedDispatch,
          user?.fullName || ''
        );
      }
    }
  };

  const notParticipateButton = isActiveNotParticipate ? (
    <Button className="NotParticipate" onClick={() => setModalNotParticipate(true)}>
      Não Participar
    </Button>
  ) : (
    <Button className="NotParticipate disableBtnNotParticipate" disabled={true}>
      {notParticipateStatusLabel}
    </Button>
  );

  return (
    <ColumnContent>
      <FirstRow>
        <Column className="margin actBtn">
          {notParticipateButton}
        </Column>

        <Visibility visible={enableButtons}>
          <Column>
            <Tooltip text={toolTipText} disable={disableBtn}>
              <Column className={"flex-1 actBtn1 sendBtn"}>
                <CustomButton
                  onClick={() => isQuoteCanceled()}
                  height={40}
                  isDisable={disableBtn}
                  style={{ borderColor: "#BCBCBC" }}
                  disabled={disableBtn}
                >
                  <Text className="color-white">
                    {`Enviar ( ${productSelected?.length} )`}
                  </Text>
                </CustomButton>
              </Column>
            </Tooltip>
          </Column>
        </Visibility>        
      </FirstRow>

      <SecondRow>
        <Visibility visible={enableButtons}>
          <Column className="actBtn" onClick={() => setOpenItemObsModal(true)}>
            <img src={obsIconCondition ? ObsIconSaved : ObsIcon} className="obsIcon" alt="" />
          </Column>

          <SelectColumn>
            <Select
              stateName="selectCD"
              options={distributionCenter.distributionCenters}
              value={selectCD}
              skipSelectOption={false}
              className="selectCd bg-white outline actBtn"
              onChange={(e) => changeCDAndResetQuote(e.target.value)}
              defaultBlankValue="Selecione o CD"
            />
          </SelectColumn>
        </Visibility>
      </SecondRow>
    </ColumnContent>
  );
};